import './Result.css';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { State } from './PasswordChange'

const Result = () => {
    const { resultFlag } = useContext(State);
    const { t } = useTranslation();
    return (
        <>
            {resultFlag ? (
                <div id="succeeded">
                    <p>{t('result.successMessage')}</p>
                    <p>{t('result.successInstruction')}</p>
                </div>
            ) : (
                <div id="failed">
                    <p>{t('result.errorMessage')}</p>
                    <p>{t('result.errorReason')}</p>
                </div>
            )}
        </>
    )
}

export default Result
